import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { cloneDeep } from 'lodash-es';
import { FileUploader, FileUploaderOptions } from 'ng2-file-upload';

@Component({
    selector: 'app-file-upload',
    templateUrl: './file-upload.component.html',
    styleUrls: ['./file-upload.component.scss'],
    standalone: false
})
export class FileUploadComponent implements OnInit {
  @Input() currentFileCount = 0;
  @Input() allowedMimeTypes: Array<string> = [];
  @Input() allowMultiple = false;
  @Input() disabledFileSelection = false;
  @Output() handleFileSelected = new EventEmitter();
  uploader!: FileUploader;

  constructor() {}

  ngOnInit(): void {
    this.uploader = this.createFileUploader();
  }

  createFileUploader(options: FileUploaderOptions = { url: '' }) {
    const uploaderOptions = Object.assign(
      {
        allowedMimeType: this.allowedMimeTypes,
        autoUpload: false,
        isHTML5: true,
        queueLimit: 1,
        disableMultipart: false, // Set to false if API only accepts form data
        formatDataFunctionIsAsync: false, // Has to be false when using disableMultipart
      },
      options,
    );

    // I hate this plugin and can't wait to replace it. Hopefully we can find a framework agnostic solution.
    return (this.uploader = new FileUploader(uploaderOptions));
  }

  public dropped(file: File[]): void {
    this.handleFileSelected.emit(file);
  }

  onFileChange($event: Event) {
    const target = $event.target as HTMLInputElement;
    const files = target.files;
    // If we reset the input field without cloning the files selected, this often results in
    // the data not being available on the emitted event.
    // @ts-ignore
    this.handleFileSelected.emit(cloneDeep([...files]));

    // Reset the input field to an empty value.
    target.value = '';
  }
}
